import React, { Fragment } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  scheadtourviewdetail,
  schprofileview,
} from "../../../../../services/schoolhead";
import dotracking from "../../../../trackinglogs";
import trackobj from "../../../../trackingpages.json";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import {
  addathleteplayerlist,
  checkextpaymentpaidornot,
  checkpaymentpaidornot,
  paymentsuccess,
  toureditphotosummary,
  tourentryfreepayment,
  tourentryofflinepayment,
  tourextaccinfo,
  tourextreceipt,
  tourpayment,
  toursummary,
} from "../../../../../services/common";
import moment from "moment";
import { toast } from "react-toastify";
import {
  crmprofileview,
  crmtourviewdetail,
} from "../../../../../services/cityregionaladmin";
import { tourviewdetail } from "../../../../../services/superadmin";
import exportUrl from "../../../../../exportUtl";
import {
  swimaddathleteplayerlist,
  swimcheckextpaymentpaidornot,
  swimcheckpaymentpaidornot,
  swimpaymentsuccess,
  swimtourentryfreepayment,
  swimtourentryofflinepayment,
  swimtourextaccinfo,
  swimtourextreceipt,
  swimtourpayment,
  swimtoursummary,
} from "../../../../../services/swimmingapi";
import { coachtourviewdetail } from "../../../../../services/coach";
import ImageCropperModal from "../../../../foundation/imagecropmodal";
export const SummaryPlayers = () => {
  const [tname, setTName] = useState("");
  const [tfree, setTFree] = useState("");
  const [tsport, setTSport] = useState("");

  const { id, eid } = useParams();
  const navigate = useNavigate();
  const [gateway, setGateway] = useState("");
  const [accdet, setAccDet] = useState("");
  const [accpath, setAccPath] = useState("");

  const [athlete, setAthlete] = useState([]);
  const [s3path, setS3Path] = useState("");
  const [schoolid, setSchool] = useState("");

  const [adminbutton, setAdminButton] = useState("");

  const [menamt, setMenAmt] = useState(0);
  const [womenamt, setWomenAmt] = useState(0);
  const [mencnt, setMenCnt] = useState(0);
  const [womencnt, setWomenCnt] = useState(0);

  const [emencnt, setEMenCnt] = useState(0);
  const [ewomencnt, setEWomenCnt] = useState(0);
  const [etcnt, setETCnt] = useState(0);
  const [regfinalamt, setRegFinalAmt] = useState(0);
  const [addamt, setAddAmt] = useState(0);

  const [cmen, setCMen] = useState(0);
  const [cwomen, setCWomen] = useState(0);
  const [cmamt, setCMAmt] = useState(0);
  const [cwamt, setCWAmt] = useState(0);
  const [rcnt, setRCnt] = useState(0);
  const [ramt, setRAmt] = useState(0);
  const [tcnt, setTCnt] = useState(0);
  const [tamt, setTAmt] = useState(0);
  const [disamt, setDisAmt] = useState(0);
  const [disper, setDisPer] = useState(0);
  const [finalamt, setFinalAmt] = useState(0);

  const [rejrea, setRejReason] = useState("");
  const [paytype, setPayType] = useState("");
  const [grpst, setGrpSt] = useState("");

  useEffect(() => {
    if (localStorage.getItem("Role") === "1") {
      tourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setTFree(response.data.tournament.free_tournament);
          setGateway(response.data.tournament.payment_gateway_type);
          setTSport(response.data.tournament.sports_type);
          if (response.data.tournament.group_chmpionship_status !== null) {
            setGrpSt(response.data.tournament.group_chmpionship_status);
          }
          // if (response.data.tournament.payment_gateway_type == 1) {
          //   checkpaymentpaidornot(id, eid, 0).then((response) => {
          //     if (response.status === true) {
          //       setAdminButton(response.data.Payment_Status);
          //     }
          //   });
          // } else if (response.data.tournament.payment_gateway_type === 2) {
          //   navigate("/superadmin/confirmation/" + id + "/" + eid);
          // }

          if (
            response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
          ) {
            if (response.data.tournament.payment_gateway_type === 2) {
              tourextaccinfo(id).then((res) => {
                if (res.status === true) {
                  if (res.data.account_info !== null) {
                    setAccDet(res.data.account_info);
                    setAccPath(
                      exportUrl +
                      "storage/app/public/data/tournament/account_qr/"
                    );
                  }
                }
              });
            }
            listplayers(id, eid);

            toursummary(id, eid).then((response) => {
              if (response.status === true) {
                setCMen(response.data.no_of_men);
                setCWomen(response.data.no_of_women);
                setCMAmt(response.data.total_male_amount);
                setCWAmt(response.data.total_female_amount);
                setRCnt(response.data.total_relay_total_count);
                setRAmt(response.data.total_relay_total_amount);
                setTCnt(response.data.total_count);
                setTAmt(response.data.over_all_amount);
                setDisPer(response.data.discount_percentage);
                setDisAmt(response.data.discount_amount);
                setFinalAmt(response.data.final_amount);
                setRegFinalAmt(response.data.registration_fee);
                setAddAmt(response.data.additional_fee_amount);

                setEMenCnt(response.data.total_male_event_count);
                setEWomenCnt(response.data.total_female_event_count);
                setETCnt(
                  parseInt(response.data.total_male_event_count) +
                  parseInt(response.data.total_female_event_count)
                );
                setMenCnt(
                  response.data.no_of_men + response.data.total_relay_male_count
                );
                setWomenCnt(
                  response.data.no_of_women +
                  response.data.total_relay_female_count
                );
                setMenAmt(
                  response.data.total_male_amount +
                  response.data.total_relay_male_amount
                );
                setWomenAmt(
                  response.data.total_female_amount +
                  response.data.total_relay_female_amount
                );
              }
            });
          } else if (
            response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
          ) {
            if (response.data.tournament.payment_gateway_type === 2) {
              swimtourextaccinfo(id).then((res) => {
                if (res.status === true) {
                  if (res.data.account_info !== null) {
                    setAccDet(res.data.account_info);
                    setAccPath(
                      exportUrl +
                      "storage/app/public/data/tournament/account_qr/"
                    );
                  }
                }
              });
            }
            swimaddathleteplayerlist(id, eid).then((response) => {
              if (response.status === true) {
                setAthlete(response.data.details);
                setS3Path(response.data.s3path);
              }
            });
            swimtoursummary(id, eid).then((response) => {
              if (response.status === true) {
                setCMen(response.data.no_of_men);
                setCWomen(response.data.no_of_women);
                setCMAmt(response.data.total_male_amount);
                setCWAmt(response.data.total_female_amount);
                setRCnt(response.data.total_relay_total_count);
                setRAmt(response.data.total_relay_total_amount);
                setTCnt(response.data.total_count);
                setTAmt(response.data.over_all_amount);
                setDisPer(response.data.discount_percentage);
                setDisAmt(response.data.discount_amount);
                setFinalAmt(response.data.final_amount);
                setRegFinalAmt(response.data.registration_fee);
                setAddAmt(response.data.additional_fee_amount);

                setEMenCnt(response.data.total_male_event_count);
                setEWomenCnt(response.data.total_female_event_count);
                setETCnt(
                  parseInt(response.data.total_male_event_count) +
                  parseInt(response.data.total_female_event_count)
                );
                setMenCnt(
                  response.data.no_of_men + response.data.total_relay_male_count
                );
                setWomenCnt(
                  response.data.no_of_women +
                  response.data.total_relay_female_count
                );
                setMenAmt(
                  response.data.total_male_amount +
                  response.data.total_relay_male_amount
                );
                setWomenAmt(
                  response.data.total_female_amount +
                  response.data.total_relay_female_amount
                );
              }
            });
          }

          // toursummary(id, eid).then((response) => {
          //   if (response.status === true) {
          //     setCMen(response.data.no_of_men);
          //     setCWomen(response.data.no_of_women);
          //     setCMAmt(response.data.total_male_amount);
          //     setCWAmt(response.data.total_female_amount);
          //     setRCnt(response.data.total_relay_total_count);
          //     setRAmt(response.data.total_relay_total_amount);
          //     setTCnt(response.data.total_count);
          //     setTAmt(response.data.over_all_amount);
          //     setDisPer(response.data.discount_percentage);
          //     setDisAmt(response.data.discount_amount);
          //     setFinalAmt(response.data.final_amount);
          //     setRegFinalAmt(response.data.registration_fee);
          //     setAddAmt(response.data.additional_fee_amount);

          //     setEMenCnt(response.data.total_male_event_count);
          //     setEWomenCnt(response.data.total_female_event_count);
          //     setETCnt(
          //       parseInt(response.data.total_male_event_count) +
          //         parseInt(response.data.total_female_event_count)
          //     );
          //     setMenCnt(
          //       response.data.no_of_men + response.data.total_relay_male_count
          //     );
          //     setWomenCnt(
          //       response.data.no_of_women +
          //         response.data.total_relay_female_count
          //     );
          //     setMenAmt(
          //       response.data.total_male_amount +
          //         response.data.total_relay_male_amount
          //     );
          //     setWomenAmt(
          //       response.data.total_female_amount +
          //         response.data.total_relay_female_amount
          //     );
          //   }
          // });
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      crmtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setTFree(response.data.tournament.free_tournament);
          setGateway(response.data.tournament.payment_gateway_type);
          setTSport(response.data.tournament.sports_type);
          if (response.data.tournament.group_chmpionship_status !== null) {
            setGrpSt(response.data.tournament.group_chmpionship_status);
          }
          if (
            response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
          ) {
            if (response.data.tournament.payment_gateway_type == 1) {
              checkpaymentpaidornot(id, eid, 0).then((response) => {
                if (response.status === true) {
                  setAdminButton(response.data.Payment_Status);
                  if (response.data.Payment_Status === "Paid") {
                    navigate("/cityregional/confirmation/" + id + "/" + eid);
                  }
                }
              });
            } else if (response.data.tournament.payment_gateway_type === 2) {
              // navigate("/cityregional/confirmation/" + id + "/" + eid);
              checkextpaymentpaidornot(id, eid).then((res) => {
                if (res.status === true && res.data.exteral_receipt !== null) {
                  setPayType(res.data.exteral_receipt.approve_or_reject);
                  if (res.data.exteral_receipt.approve_or_reject == 2) {
                    navigate("/cityregional/playerlist/" + id + "/" + eid);
                  } else {
                    navigate("/cityregional/confirmation/" + id + "/" + eid);
                  }
                } else {
                  navigate("/cityregional/confirmation/" + id + "/" + eid);
                }
              });
            }
            listplayers(id, eid);


            toursummary(id, eid).then((response) => {
              if (response.status === true) {
                setCMen(response.data.no_of_men);
                setCWomen(response.data.no_of_women);
                setCMAmt(response.data.total_male_amount);
                setCWAmt(response.data.total_female_amount);
                setRCnt(response.data.total_relay_total_count);
                setRAmt(response.data.total_relay_total_amount);
                setTCnt(response.data.total_count);
                setTAmt(response.data.over_all_amount);
                setDisPer(response.data.discount_percentage);
                setDisAmt(response.data.discount_amount);
                setFinalAmt(response.data.final_amount);
                setRegFinalAmt(response.data.registration_fee);
                setAddAmt(response.data.additional_fee_amount);

                setEMenCnt(response.data.total_male_event_count);
                setEWomenCnt(response.data.total_female_event_count);
                setETCnt(
                  parseInt(response.data.total_male_event_count) +
                  parseInt(response.data.total_female_event_count)
                );

                setMenCnt(
                  response.data.no_of_men + response.data.total_relay_male_count
                );
                setWomenCnt(
                  response.data.no_of_women +
                  response.data.total_relay_female_count
                );
                setMenAmt(
                  response.data.total_male_amount +
                  response.data.total_relay_male_amount
                );
                setWomenAmt(
                  response.data.total_female_amount +
                  response.data.total_relay_female_amount
                );
              }
            });
          } else if (
            response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
          ) {
            if (response.data.tournament.payment_gateway_type == 1) {
              swimcheckpaymentpaidornot(id, eid, 0).then((response) => {
                if (response.status === true) {
                  setAdminButton(response.data.Payment_Status);
                  if (response.data.Payment_Status === "Paid") {
                    navigate("/cityregional/confirmation/" + id + "/" + eid);
                  }
                }
              });
            } else if (response.data.tournament.payment_gateway_type === 2) {
              // navigate("/cityregional/confirmation/" + id + "/" + eid);
              swimcheckextpaymentpaidornot(id, eid).then((res) => {
                if (res.status === true && res.data.exteral_receipt !== null) {
                  setPayType(res.data.exteral_receipt.approve_or_reject);
                  if (res.data.exteral_receipt.approve_or_reject == 2) {
                    navigate("/cityregional/swimplayerlist/" + id + "/" + eid);
                  } else {
                    navigate("/cityregional/confirmation/" + id + "/" + eid);
                  }
                } else {
                  navigate("/cityregional/confirmation/" + id + "/" + eid);
                }
              });
            }

            swimaddathleteplayerlist(id, eid).then((response) => {
              if (response.status === true) {
                setAthlete(response.data.details);
                setS3Path(response.data.s3path);
              }
            });
            swimtoursummary(id, eid).then((response) => {
              if (response.status === true) {
                setCMen(response.data.no_of_men);
                setCWomen(response.data.no_of_women);
                setCMAmt(response.data.total_male_amount);
                setCWAmt(response.data.total_female_amount);
                setRCnt(response.data.total_relay_total_count);
                setRAmt(response.data.total_relay_total_amount);
                setTCnt(response.data.total_count);
                setTAmt(response.data.over_all_amount);
                setDisPer(response.data.discount_percentage);
                setDisAmt(response.data.discount_amount);
                setFinalAmt(response.data.final_amount);
                setRegFinalAmt(response.data.registration_fee);
                setAddAmt(response.data.additional_fee_amount);

                setEMenCnt(response.data.total_male_event_count);
                setEWomenCnt(response.data.total_female_event_count);
                setETCnt(
                  parseInt(response.data.total_male_event_count) +
                  parseInt(response.data.total_female_event_count)
                );

                setMenCnt(
                  response.data.no_of_men + response.data.total_relay_male_count
                );
                setWomenCnt(
                  response.data.no_of_women +
                  response.data.total_relay_female_count
                );
                setMenAmt(
                  response.data.total_male_amount +
                  response.data.total_relay_male_amount
                );
                setWomenAmt(
                  response.data.total_female_amount +
                  response.data.total_relay_female_amount
                );
              }
            });
          }
        }
      });
    } else if (localStorage.getItem("Role") === "4") {
      scheadtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTFree(response.data.tournament.free_tournament);
          setTName(response.data.tournament.meet_name);
          setGateway(response.data.tournament.payment_gateway_type);
          setTSport(response.data.tournament.sports_type);
          if (response.data.tournament.group_chmpionship_status !== null) {
            setGrpSt(response.data.tournament.group_chmpionship_status);
          }
          if (
            response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
          ) {
            if (response.data.tournament.payment_gateway_type === 2) {
              tourextaccinfo(id).then((res) => {
                if (res.status === true) {
                  if (res.data.account_info !== null) {
                    setAccDet(res.data.account_info);
                    // setAccPath(res.data.qr_path);
                    setAccPath(
                      exportUrl +
                      "storage/app/public/data/tournament/account_qr/"
                    );
                  }
                }
              });
            }
          } else if (
            response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
          ) {
            if (response.data.tournament.payment_gateway_type === 2) {
              swimtourextaccinfo(id).then((res) => {
                if (res.status === true) {
                  if (res.data.account_info !== null) {
                    setAccDet(res.data.account_info);
                    // setAccPath(res.data.qr_path);
                    setAccPath(
                      exportUrl +
                      "storage/app/public/data/tournament/account_qr/"
                    );
                  }
                }
              });
            }
          }
          schprofileview().then((resp) => {
            if (resp.status === true) {
              setSchool(resp.data.school_id);

              if (
                response.data.tournament.sports_type.toUpperCase() ==
                "ATHLETICS"
              ) {
                if (response.data.tournament.payment_gateway_type === 1) {
                  checkpaymentpaidornot(id, resp.data.school_id, 0).then(
                    (res) => {
                      if (res.status === true) {
                        setAdminButton(res.data.Payment_Status);

                        if (res.data.Payment_Status === "Paid") {
                          navigate("/schoolhead/confirmation/" + id);
                        }
                      }
                    }
                  );
                } else if (
                  response.data.tournament.payment_gateway_type === 2
                ) {
                  checkextpaymentpaidornot(id, resp.data.school_id).then(
                    (res) => {
                      if (res.status === true) {
                        if (res.data.exteral_receipt !== null) {
                          setPayType(
                            res.data.exteral_receipt.approve_or_reject
                          );

                          if (
                            res.data.exteral_receipt.approve_or_reject === 0
                          ) {
                            setAdminButton("Paid");
                          }
                          if (
                            res.data.exteral_receipt.approve_or_reject === 0 ||
                            res.data.exteral_receipt.approve_or_reject === 1
                          ) {
                            setRejReason("");
                            navigate("/schoolhead/confirmation/" + id);
                          } else {
                            setRejReason(
                              res.data.exteral_receipt.approve_or_reject_reason
                            );
                          }
                        }
                      }
                    }
                  );
                }
                listplayers(id, resp.data.school_id);

                toursummary(id, resp.data.school_id).then((response) => {
                  if (response.status === true) {
                    setCMen(response.data.no_of_men);
                    setCWomen(response.data.no_of_women);
                    setCMAmt(response.data.total_male_amount);
                    setCWAmt(response.data.total_female_amount);
                    setRCnt(response.data.total_relay_total_count);
                    setRAmt(response.data.total_relay_total_amount);
                    setTCnt(response.data.total_count);
                    setTAmt(response.data.over_all_amount);
                    setDisPer(response.data.discount_percentage);
                    setDisAmt(response.data.discount_amount);
                    setFinalAmt(response.data.final_amount);
                    setRegFinalAmt(response.data.registration_fee);
                    setAddAmt(response.data.additional_fee_amount);
                    setEMenCnt(response.data.total_male_event_count);
                    setEWomenCnt(response.data.total_female_event_count);
                    setETCnt(
                      parseInt(response.data.total_male_event_count) +
                      parseInt(response.data.total_female_event_count)
                    );

                    setMenCnt(
                      response.data.no_of_men +
                      response.data.total_relay_male_count
                    );
                    setWomenCnt(
                      response.data.no_of_women +
                      response.data.total_relay_female_count
                    );
                    setMenAmt(
                      response.data.total_male_amount +
                      response.data.total_relay_male_amount
                    );
                    setWomenAmt(
                      response.data.total_female_amount +
                      response.data.total_relay_female_amount
                    );
                  }
                });
              } else if (
                response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
              ) {
                if (response.data.tournament.payment_gateway_type === 1) {
                  swimcheckpaymentpaidornot(id, resp.data.school_id, 0).then(
                    (res) => {
                      if (res.status === true) {
                        setAdminButton(res.data.Payment_Status);

                        if (res.data.Payment_Status === "Paid") {
                          navigate("/schoolhead/confirmation/" + id);
                        }
                      }
                    }
                  );
                } else if (
                  response.data.tournament.payment_gateway_type === 2
                ) {
                  swimcheckextpaymentpaidornot(id, resp.data.school_id).then(
                    (res) => {
                      if (res.status === true) {
                        if (res.data.exteral_receipt !== null) {
                          setPayType(
                            res.data.exteral_receipt.approve_or_reject
                          );

                          if (
                            res.data.exteral_receipt.approve_or_reject === 0
                          ) {
                            setAdminButton("Paid");
                          }
                          if (
                            res.data.exteral_receipt.approve_or_reject === 0 ||
                            res.data.exteral_receipt.approve_or_reject === 1
                          ) {
                            setRejReason("");
                            navigate("/schoolhead/confirmation/" + id);
                          } else {
                            setRejReason(
                              res.data.exteral_receipt.approve_or_reject_reason
                            );
                          }
                        }
                      }
                    }
                  );
                }

                swimaddathleteplayerlist(id, resp.data.school_id).then(
                  (response) => {
                    if (response.status === true) {
                      setAthlete(response.data.details);
                      setS3Path(response.data.s3path);
                    }
                  }
                );
                swimtoursummary(id, resp.data.school_id).then((response) => {
                  if (response.status === true) {
                    setCMen(response.data.no_of_men);
                    setCWomen(response.data.no_of_women);
                    setCMAmt(response.data.total_male_amount);
                    setCWAmt(response.data.total_female_amount);
                    setRCnt(response.data.total_relay_total_count);
                    setRAmt(response.data.total_relay_total_amount);
                    setTCnt(response.data.total_count);
                    setTAmt(response.data.over_all_amount);
                    setDisPer(response.data.discount_percentage);
                    setDisAmt(response.data.discount_amount);
                    setFinalAmt(response.data.final_amount);
                    setRegFinalAmt(response.data.registration_fee);
                    setAddAmt(response.data.additional_fee_amount);
                    setEMenCnt(response.data.total_male_event_count);
                    setEWomenCnt(response.data.total_female_event_count);
                    setETCnt(
                      parseInt(response.data.total_male_event_count) +
                      parseInt(response.data.total_female_event_count)
                    );

                    setMenCnt(
                      response.data.no_of_men +
                      response.data.total_relay_male_count
                    );
                    setWomenCnt(
                      response.data.no_of_women +
                      response.data.total_relay_female_count
                    );
                    setMenAmt(
                      response.data.total_male_amount +
                      response.data.total_relay_male_amount
                    );
                    setWomenAmt(
                      response.data.total_female_amount +
                      response.data.total_relay_female_amount
                    );
                  }
                });
              }
            }
          });
        }
      });
    } else if (localStorage.getItem("Role") === "7") {
      coachtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setTFree(response.data.tournament.free_tournament);
          setGateway(response.data.tournament.payment_gateway_type);
          setTSport(response.data.tournament.sports_type);
          if (response.data.tournament.group_chmpionship_status !== null) {
            setGrpSt(response.data.tournament.group_chmpionship_status);
          }
          // if (response.data.tournament.payment_gateway_type == 1) {
          //   checkpaymentpaidornot(id, eid, 0).then((response) => {
          //     if (response.status === true) {
          //       setAdminButton(response.data.Payment_Status);
          //     }
          //   });
          // } else if (response.data.tournament.payment_gateway_type === 2) {
          //   navigate("/superadmin/confirmation/" + id + "/" + eid);
          // }

          if (
            response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
          ) {
            if (response.data.tournament.payment_gateway_type === 2) {
              tourextaccinfo(id).then((res) => {
                if (res.status === true) {
                  if (res.data.account_info !== null) {
                    setAccDet(res.data.account_info);
                    setAccPath(
                      exportUrl +
                      "storage/app/public/data/tournament/account_qr/"
                    );
                  }
                }
              });
            }
            listplayers(id, eid);


            toursummary(id, eid).then((response) => {
              if (response.status === true) {
                setCMen(response.data.no_of_men);
                setCWomen(response.data.no_of_women);
                setCMAmt(response.data.total_male_amount);
                setCWAmt(response.data.total_female_amount);
                setRCnt(response.data.total_relay_total_count);
                setRAmt(response.data.total_relay_total_amount);
                setTCnt(response.data.total_count);
                setTAmt(response.data.over_all_amount);
                setDisPer(response.data.discount_percentage);
                setDisAmt(response.data.discount_amount);
                setFinalAmt(response.data.final_amount);
                setRegFinalAmt(response.data.registration_fee);
                setAddAmt(response.data.additional_fee_amount);

                setEMenCnt(response.data.total_male_event_count);
                setEWomenCnt(response.data.total_female_event_count);
                setETCnt(
                  parseInt(response.data.total_male_event_count) +
                  parseInt(response.data.total_female_event_count)
                );
                setMenCnt(
                  response.data.no_of_men + response.data.total_relay_male_count
                );
                setWomenCnt(
                  response.data.no_of_women +
                  response.data.total_relay_female_count
                );
                setMenAmt(
                  response.data.total_male_amount +
                  response.data.total_relay_male_amount
                );
                setWomenAmt(
                  response.data.total_female_amount +
                  response.data.total_relay_female_amount
                );
              }
            });
          } else if (
            response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
          ) {
            if (response.data.tournament.payment_gateway_type === 2) {
              swimtourextaccinfo(id).then((res) => {
                if (res.status === true) {
                  if (res.data.account_info !== null) {
                    setAccDet(res.data.account_info);
                    setAccPath(
                      exportUrl +
                      "storage/app/public/data/tournament/account_qr/"
                    );
                  }
                }
              });
            }
            swimaddathleteplayerlist(id, eid).then((response) => {
              if (response.status === true) {
                setAthlete(response.data.details);
                setS3Path(response.data.s3path);
              }
            });
            swimtoursummary(id, eid).then((response) => {
              if (response.status === true) {
                setCMen(response.data.no_of_men);
                setCWomen(response.data.no_of_women);
                setCMAmt(response.data.total_male_amount);
                setCWAmt(response.data.total_female_amount);
                setRCnt(response.data.total_relay_total_count);
                setRAmt(response.data.total_relay_total_amount);
                setTCnt(response.data.total_count);
                setTAmt(response.data.over_all_amount);
                setDisPer(response.data.discount_percentage);
                setDisAmt(response.data.discount_amount);
                setFinalAmt(response.data.final_amount);
                setRegFinalAmt(response.data.registration_fee);
                setAddAmt(response.data.additional_fee_amount);

                setEMenCnt(response.data.total_male_event_count);
                setEWomenCnt(response.data.total_female_event_count);
                setETCnt(
                  parseInt(response.data.total_male_event_count) +
                  parseInt(response.data.total_female_event_count)
                );
                setMenCnt(
                  response.data.no_of_men + response.data.total_relay_male_count
                );
                setWomenCnt(
                  response.data.no_of_women +
                  response.data.total_relay_female_count
                );
                setMenAmt(
                  response.data.total_male_amount +
                  response.data.total_relay_male_amount
                );
                setWomenAmt(
                  response.data.total_female_amount +
                  response.data.total_relay_female_amount
                );
              }
            });
          }


        }
      });
    }
  }, []);
  function listplayers(tid, sid) {
    addathleteplayerlist(tid, sid).then((response) => {
      if (response.status === true) {
        setAthlete(response.data.details);
        setS3Path(response.data.s3path);
      }
    });
  }
  function backlist() {
    if (localStorage.getItem("Role") === "1") {
      dotracking(
        "back button in tournament player list for school (" +
        eid +
        ") in " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.touraddaplayerheading
      );
      if (tsport.toUpperCase() == "SWIMMING") {
        navigate("/superadmin/swimaddathletes/" + id + "/" + eid);
      } else {
        navigate("/superadmin/addathletes/" + id + "/" + eid);
      }
    } else if (localStorage.getItem("Role") === "3") {
      dotracking(
        "back button in tournament player list for school (" +
        eid +
        ") in " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.touraddaplayerheading
      );

      if (tsport.toUpperCase() == "SWIMMING") {
        navigate("/cityregional/swimaddathletes/" + id + "/" + eid);
      } else {
        navigate("/cityregional/addathletes/" + id + "/" + eid);
      }
    } else if (localStorage.getItem("Role") === "4") {
      dotracking(
        "back button in tournament player list for " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.touraddaplayerheading
      );
      navigate("/schoolhead/addathletes/" + id);
      if (tsport.toUpperCase() == "SWIMMING") {
        navigate("/schoolhead/swimaddathletes/" + id);
      } else {
        navigate("/schoolhead/addathletes/" + id);
      }
    } else if (localStorage.getItem("Role") === "7") {
      dotracking(
        "back button in tournament player list for school (" +
        eid +
        ") in " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.touraddaplayerheading
      );
      if (tsport.toUpperCase() == "SWIMMING") {
        navigate("/coach/swimaddathletes/" + id + "/" + eid);
      } else {
        navigate("/coach/addathletes/" + id + "/" + eid);
      }
    }
  }

  function addlist() {
    if (localStorage.getItem("Role") === "1") {
      dotracking(
        "add players button in summary for school (" +
        eid +
        ") in " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.tourplayerheading
      );
      if (tsport.toUpperCase() == "SWIMMING") {
        navigate("/superadmin/swimplayerlist/" + id + "/" + eid);
      } else {
        navigate("/superadmin/playerlist/" + id + "/" + eid);
      }
    } else if (localStorage.getItem("Role") === "3") {
      dotracking(
        "add players button in summary for school (" +
        eid +
        ") in " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.tourplayerheading
      );
      if (tsport.toUpperCase() == "SWIMMING") {
        navigate("/cityregional/swimplayerlist/" + id + "/" + eid);
      } else {
        navigate("/cityregional/playerlist/" + id + "/" + eid);
      }
      // navigate("/cityregional/playerlist/" + id + "/" + eid);
    } else if (localStorage.getItem("Role") === "4") {
      dotracking(
        "add players button in summary for " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.tourplayerheading
      );
      // navigate("/schoolhead/playerlist/" + id);
      if (tsport.toUpperCase() == "SWIMMING") {
        navigate("/schoolhead/swimplayerlist/" + id);
      } else {
        navigate("/schoolhead/playerlist/" + id);
      }
    }
  }
  const [loading, setLoading] = useState(false);

  function entrysubmit() {
    setLoading(true);
    const tempData = new FormData();
    tempData.append("admin_id", localStorage.getItem("UID"));
    if (localStorage.getItem("Role") !== "4") {
      tempData.append("school_id", eid);
    } else {
      tempData.append("school_id", schoolid);
    }

    tempData.append("tournament_meet_id", id);
    tempData.append("total_men", mencnt);
    tempData.append("total_women", womencnt);
    tempData.append("total_men_amount", menamt);
    tempData.append("total_women_amount", womenamt);
    tempData.append("total_relay_fees", ramt);
    tempData.append("amount", finalamt);
    tempData.append("over_all_amount", tamt);
    tempData.append("discount_amount", disamt);
    if (adminbutton === "Paid") {
      tempData.append("submit_or_update", 1);
    } else {
      tempData.append("submit_or_update", 0);
    }

    dotracking(
      "submit & pay button in summary for " +
      tname +
      " (" +
      id +
      ") tournament $$ " +
      trackobj.confirmplayerheading
    );
    if (tsport.toUpperCase() === "ATHLETICS") {
      if (tfree === "Y") {
        tourentryfreepayment(tempData).then((response) => {
          if (response.status === true) {
            setLoading(false);
            navigate("/superadmin/confirmation/" + id + "/" + eid);
          } else {
            setLoading(false);
            toast.error(response.message);
          }
        });
      } else if (tfree === "N") {
        tourentryofflinepayment(tempData).then((response) => {
          if (response.status === true) {
            setLoading(false);
            navigate("/superadmin/confirmation/" + id + "/" + eid);
          } else {
            setLoading(false);
            toast.error(response.message);
          }
        });
      }
    } else if (tsport.toUpperCase() === "SWIMMING") {
      if (tfree === "Y") {
        swimtourentryfreepayment(tempData).then((response) => {
          if (response.status === true) {
            setLoading(false);
            navigate("/superadmin/confirmation/" + id + "/" + eid);
          } else {
            setLoading(false);
            toast.error(response.message);
          }
        });
      } else if (tfree === "N") {
        swimtourentryofflinepayment(tempData).then((response) => {
          if (response.status === true) {
            setLoading(false);
            navigate("/superadmin/confirmation/" + id + "/" + eid);
          } else {
            setLoading(false);
            toast.error(response.message);
          }
        });
      }
    }
  }
  function paysubmit() {
    if (tfree === "Y") {
      setLoading(true);
      const tempData = new FormData();
      tempData.append("admin_id", localStorage.getItem("UID"));
      if (localStorage.getItem("Role") !== "4") {
        tempData.append("school_id", eid);
      } else {
        tempData.append("school_id", schoolid);
      }

      tempData.append("tournament_meet_id", id);
      tempData.append("total_men", mencnt);
      tempData.append("total_women", womencnt);
      tempData.append("total_men_amount", menamt);
      tempData.append("total_women_amount", womenamt);
      tempData.append("total_relay_fees", ramt);
      tempData.append("amount", finalamt);
      tempData.append("over_all_amount", tamt);
      tempData.append("discount_amount", disamt);
      // if(adminbutton === "Paid"){
      //   tempData.append("submit_or_update", 1);
      // }else{
      tempData.append("submit_or_update", 0);
      // }
      dotracking(
        "submit & pay button in summary for " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.confirmplayerheading
      );
      if (tsport.toUpperCase() === "ATHLETICS") {
        tourentryfreepayment(tempData).then((response) => {
          if (response.status === true) {
            setLoading(false);
            if (localStorage.getItem("Role") === "3") {
              navigate("/cityregional/confirmation/" + id + "/" + eid);
            } else if (localStorage.getItem("Role") === "4") {
              navigate("/schoolhead/confirmation/" + id);
            } else if (localStorage.getItem("Role") === "7") {
              navigate("/coach/confirmation/" + id + "/" + eid);
            }
          } else {
            setLoading(false);
            toast.error(response.message);
          }
        });
      } else if (tsport.toUpperCase() === "SWIMMING") {
        swimtourentryfreepayment(tempData).then((response) => {
          if (response.status === true) {
            setLoading(false);
            if (localStorage.getItem("Role") === "3") {
              navigate("/cityregional/confirmation/" + id + "/" + eid);
            } else if (localStorage.getItem("Role") === "4") {
              navigate("/schoolhead/confirmation/" + id);
            }
          } else {
            setLoading(false);
            toast.error(response.message);
          }
        });
      }
    } else if (tfree === "N") {
      if (tamt !== 0) {
        setLoading(true);
        const tempData = new FormData();
        tempData.append("admin_id", localStorage.getItem("UID"));
        if (localStorage.getItem("Role") !== "4") {
          tempData.append("school_id", eid);
        } else {
          tempData.append("school_id", schoolid);
        }

        tempData.append("tournament_meet_id", id);
        tempData.append("total_men", mencnt);
        tempData.append("total_women", womencnt);
        tempData.append("total_men_amount", menamt);
        tempData.append("total_women_amount", womenamt);
        tempData.append("total_relay_fees", ramt);
        tempData.append("amount", finalamt);
        tempData.append("over_all_amount", tamt);
        tempData.append("discount_amount", disamt);

        dotracking(
          "submit & pay button in summary for " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.confirmplayerheading
        );
        if (tsport.toUpperCase() === "ATHLETICS") {
          tourpayment(tempData).then((response) => {
            if (response.status === true) {
              setLoading(false);
              paynow(
                response.data.RAZORPAY_KEY,
                response.data.entry_table.orderid,
                response.data.entry_table.total_amount,
                response.data.entry_table.id
              );
            } else {
              setLoading(false);
              toast.error(response.message);
            }
          });
        } else if (tsport.toUpperCase() === "SWIMMING") {
          swimtourpayment(tempData).then((response) => {
            if (response.status === true) {
              setLoading(false);
              paynow(
                response.data.RAZORPAY_KEY,
                response.data.entry_table.orderid,
                response.data.entry_table.total_amount,
                response.data.entry_table.id
              );
            } else {
              setLoading(false);
              toast.error(response.message);
            }
          });
        }
      } else {
        toast.error("Please add players before submit");
      }
    }
  }
  async function paynow(pkey, ordid, amt, pid) {
    const options = {
      key: pkey,
      order_id: ordid,
      name: "League Management Platform",
      description: "Tournament Registration",
      image: require("../../../../../assets/images/favicon.png"),
      handler: function (response) {
        const temp = new FormData();
        if (localStorage.getItem("Role") === "3") {
          temp.append("school_id", eid);
        } else {
          temp.append("school_id", schoolid);
        }
        temp.append("admin_id", localStorage.getItem("UID"));
        temp.append("razorpay_payment_id", response.razorpay_payment_id);
        temp.append("totalAmount", amt);
        temp.append("current_meet_id", id);
        temp.append("order_id", ordid);
        temp.append("current_ins_id", pid);
        setLoading(true);
        if (tsport.toUpperCase() === "ATHLETICS") {
          paymentsuccess(temp).then((response) => {
            if (response.status === true) {
              setLoading(false);
              if (localStorage.getItem("Role") === "3") {
                navigate("/cityregional/confirmation/" + id + "/" + eid);
              } else if (localStorage.getItem("Role") === "4") {
                navigate("/schoolhead/confirmation/" + id);
              }
            }
          });
        } else if (tsport.toUpperCase() === "SWIMMING") {
          swimpaymentsuccess(temp).then((response) => {
            if (response.status === true) {
              setLoading(false);
              if (localStorage.getItem("Role") === "3") {
                navigate("/cityregional/confirmation/" + id + "/" + eid);
              } else if (localStorage.getItem("Role") === "4") {
                navigate("/schoolhead/confirmation/" + id);
              }
            }
          });
        }
      },
      prefill: {
        email: "",
        phone_number: "",
      },
    };
    const paymentObj = new window.Razorpay(options);
    paymentObj.open();
  }
  function errorhandle(ev) {
    ev.target.src = require("../../../../../assets/images/users.png");
    ev.target.onerror = null;
  }
  const [oshow, setOshow] = useState(false);
  const [oimage, setOImage] = useState("");
  function openimage(image) {
    setOImage(image);
    setOshow(true);
  }

  function closeimage() {
    setOImage("");
    setOshow(false);
  }

  const [show, setShow] = useState(false);
  function handleshow() {
    setShow(true);
    setErrMsg("");
    setRFile("");
  }

  function handleclose() {
    setRFile("");
    setErrMsg("");
    setShow(false);
  }
  const [errmsg, setErrMsg] = useState("");
  const [rfile, setRFile] = useState("");
  const [rdesc, setRDesc] = useState("");

  const [reserr, setResError] = useState("");

  function resfile(event) {
    setRFile("");
    setResError("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png|pdf)$/i)) {
        setRFile(event.target.files[0]);
      } else {
        setResError("Receipt should be jpg or jpeg or png or pdf format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setResError("Receipt size should be less than 5MB");
      }
    }
  }
  function submitrec(e) {
    e.preventDefault();
    setErrMsg("");
    if (rfile !== "") {
      if (rdesc !== "") {
        const tempData = new FormData();
        tempData.append("admin_id", localStorage.getItem("UID"));
        if (localStorage.getItem("Role") !== "4") {
          tempData.append("school_id", eid);
        } else {
          tempData.append("school_id", schoolid);
        }

        tempData.append("tournament_meet_id", id);
        tempData.append("total_men", mencnt);
        tempData.append("total_women", womencnt);
        tempData.append("total_men_amount", menamt);
        tempData.append("total_women_amount", womenamt);
        tempData.append("total_relay_fees", ramt);
        tempData.append("amount", finalamt);
        tempData.append("over_all_amount", tamt);
        tempData.append("discount_amount", disamt);
        tempData.append("receipt_image", rfile);
        tempData.append("receipt_desc", rdesc);
        tempData.append("registration_fee", regfinalamt);
        tempData.append("additional_fee", addamt);
        dotracking(
          " upload receipt button in summary for " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.confirmplayerheading
        );
        if (tsport.toUpperCase() === "ATHLETICS") {
          tourextreceipt(tempData).then((response) => {
            if (response.status === true) {
              toast.success(response.message);
              handleclose();
              if (localStorage.getItem("Role") === "3") {
                navigate("/cityregional/confirmation/" + id + "/" + eid);
              } else if (localStorage.getItem("Role") === "4") {
                navigate("/schoolhead/confirmation/" + id);
              }
            } else {
              toast.error(response.message);
            }
          });
        } else if (tsport.toUpperCase() === "SWIMMING") {
          swimtourextreceipt(tempData).then((response) => {
            if (response.status === true) {
              toast.success(response.message);
              handleclose();
              if (localStorage.getItem("Role") === "3") {
                navigate("/cityregional/confirmation/" + id + "/" + eid);
              } else if (localStorage.getItem("Role") === "4") {
                navigate("/schoolhead/confirmation/" + id);
              }
            } else {
              toast.error(response.message);
            }
          });
        }
      } else {
        setErrMsg("Please Enter Notes");
      }
    } else {
      setErrMsg("Please Upload Receipt");
    }
  }


  const [pshow, setPShow] = useState(false);
  const [pdetail, setPDetail] = useState("");
  const [previewSrc, setPreviewSrc] = useState(null);

  function handlepshow(sdet) {
    setPShow(true);
    console.log("sdet", sdet);
    setPDetail(sdet)
  }

  function handlepclose() {
    setPShow(false);
    setPreviewSrc("");
    setPDetail("");
  }

  const [photoerr, setPhotoError] = useState("");
  const [formPhoto, setFormPhoto] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [showCropper, setShowCropper] = useState(false);

  function photofile(e) {
    const file = e.target.files[0];
    if (!file) return;

    if (["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    } else {
      setPhotoError("Only JPG or PNG files are allowed");
    }
  }
  const handleCropComplete = (croppedFile) => {
    setFormPhoto(croppedFile);
    if (croppedFile instanceof Blob || croppedFile instanceof File) {
      const preview = URL.createObjectURL(croppedFile);
      setPreviewSrc(preview);
    } else {
      // if the cropper returns base64, set directly
      setPreviewSrc(croppedFile);
    }
    setPhotoError("");
    setImageSrc(null);
    setShowCropper(false);
  };

  const submitphoto = () => {
    if (!formPhoto) {
      setPhotoError("Please upload or crop a photo before submitting");
      return;
    }
    const temp = new FormData();
    temp.append("photograph", formPhoto);
    temp.append("user_id", pdetail);
    toureditphotosummary(temp).then((response) => {
      if (response.status === true) {
        handlepclose();
        if (response.data.success == false) {
          toast.error(response.data.message);
        } else {
          toast.success(response.data.message);
        }
        if (localStorage.getItem("Role") !== "4") {
          listplayers(id, eid);
        } else {
          listplayers(id, schoolid);
        }
      } else {
        toast.error(response.message);
      }
    });

  };
  return (
    <Fragment>
      <div className="side-app">
        <div className="page-header">
          <div className="breadcrumb">
            <h4 className="mb-0">Summary</h4>
          </div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Tournament</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Summary
            </li>
          </ol>
        </div>
        {loading && (
          <div className="dashloader-wrapper">
            <div className="loader"></div>
            <h3>Loading...Please do not go back or close the window.</h3>
          </div>
        )}
        {!loading && (
          <div className="row">
            <div className="col-12">
              <form className="card mt-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-7">
                      <h3>{tname}</h3>
                    </div>
                    <div className="col-md-5">
                      <div className="text-right">
                        {(localStorage.getItem("Role") === "1" ||
                          localStorage.getItem("Role") === "3" ||
                          localStorage.getItem("Role") === "4") && (
                            <>
                              <a
                                className="btn btn-success me-2"
                                onClick={addlist}
                              >
                                <i className="fa fa-plus"></i> Players
                              </a>
                            </>
                          )}

                        <a className="btn btn-gray me-2" onClick={backlist}>
                          <i className="fe fe-corner-up-left"></i> Back
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <div className="row row-sm">
                <div className="col-lg-4 col-xxl-4">
                  <Card className="custom-card mb-0">
                    <div className="card-body text-center py-3 py-3 bg-light border">
                      <h4 className="main-content-title mg-b-0 text-success">
                        View Summary
                      </h4>
                    </div>
                    {gateway == 2 && (
                      <div className="card custom-card cart-details summbox mb-0">
                        <Card.Body>
                          <h5 className="mb-3 tx-uppercase">
                            Player DETAILs{" "}
                            <span className="float-end">Amount (INR)</span>
                          </h5>
                          <dl className="dlist-align">
                            <dt className="">
                              Number of Men <code>({cmen})</code>
                            </dt>
                            <dd className="text-end ms-auto">
                              {emencnt} Events
                            </dd>
                          </dl>
                          <dl className="dlist-align">
                            <dt>
                              Number of Women <code>({cwomen})</code>
                            </dt>
                            <dd className="text-end ms-auto">
                              {ewomencnt} Events
                            </dd>
                            {/* text-danger  */}
                          </dl>
                          {/* <dl className="dlist-align border-bottom">
                            <dt>
                              Relay Team <code>({rcnt})</code>
                            </dt>
                            <dd className="text-end ms-auto">{ramt} Team</dd>
                          </dl> */}
                          <dl className="dlist-align border-top">
                            <dt>Total Events{/* <code>({tcnt})</code> */}</dt>
                            <dd className="text-end errortext ms-auto">
                              <strong>{etcnt} Events</strong>
                            </dd>
                          </dl>

                          <dl className="dlist-align border-bottom">
                            <dt>
                              Discount <code>({disper} %)</code>
                            </dt>
                            <dd className="text-end ms-auto">{disamt}</dd>
                          </dl>
                          <dl className="dlist-align tx-uppercase">
                            <dt
                              style={{ fontWeight: "bold", color: "#035399" }}
                            >
                              Registration Fee
                            </dt>
                            <dd className="text-end errortext ms-auto">
                              <strong>{regfinalamt}</strong>
                            </dd>
                          </dl>
                          <dl className="dlist-align tx-uppercase">
                            <dt
                              style={{ fontWeight: "bold", color: "#035399" }}
                            >
                              Total Amount
                            </dt>
                            <dd className="text-end errortext ms-auto">
                              <strong>{finalamt}</strong>
                            </dd>
                          </dl>
                          <div className="step-footer">
                            {/* {free === "N" && paystatus !== "paid" && ( */}
                            {localStorage.getItem("Role") !== "1" &&
                              tfree === "N" &&
                              tfree !== "" && (
                                <a
                                  onClick={handleshow}
                                  className="btn btn-success btn-block"
                                >
                                  Upload Receipt
                                </a>
                              )}
                            {localStorage.getItem("Role") !== "1" &&
                              tfree !== "N" &&
                              tfree !== "" && (
                                <a
                                  onClick={paysubmit}
                                  className="btn btn-success btn-block"
                                >
                                  Submit
                                </a>
                              )}

                            {localStorage.getItem("Role") === "1" &&
                              adminbutton === "Paid" && (
                                <a
                                  onClick={entrysubmit}
                                  className="btn btn-success btn-block"
                                >
                                  Update Entries
                                </a>
                              )}
                            {localStorage.getItem("Role") === "1" &&
                              adminbutton !== "Paid" && (
                                <a
                                  onClick={entrysubmit}
                                  className="btn btn-success btn-block"
                                >
                                  Submit Entries
                                </a>
                              )}
                            {/* )} */}
                          </div>
                        </Card.Body>
                      </div>
                    )}

                    {gateway == 1 && (
                      <div className="card custom-card cart-details summbox mb-0">
                        <Card.Body>
                          <h5 className="mb-3 tx-uppercase">
                            Player DETAILs{" "}
                            <span className="float-end">Amount (INR)</span>
                          </h5>
                          <dl className="dlist-align">
                            <dt className="">
                              Number of Men <code>({cmen})</code>
                            </dt>
                            <dd className="text-end ms-auto">{cmamt}</dd>
                          </dl>
                          <dl className="dlist-align">
                            <dt>
                              Number of Women <code>({cwomen})</code>
                            </dt>
                            <dd className="text-end ms-auto">{cwamt}</dd>
                            {/* text-danger  */}
                          </dl>
                          <dl className="dlist-align border-bottom">
                            <dt>
                              Relay Team <code>({rcnt})</code>
                            </dt>
                            <dd className="text-end ms-auto">{ramt}</dd>
                          </dl>
                          <dl className="dlist-align">
                            <dt>Total {/* <code>({tcnt})</code> */}</dt>
                            <dd className="text-end errortext ms-auto">
                              <strong>{tamt}</strong>
                            </dd>
                          </dl>

                          <dl className="dlist-align border-bottom">
                            <dt>
                              Discount <code>({disper} %)</code>
                            </dt>
                            <dd className="text-end ms-auto">{disamt}</dd>
                          </dl>
                          <dl className="dlist-align tx-uppercase">
                            <dt
                              style={{ fontWeight: "bold", color: "#035399" }}
                            >
                              Total Amount
                            </dt>
                            <dd className="text-end errortext ms-auto">
                              <strong>{finalamt}</strong>
                            </dd>
                          </dl>
                          <div className="step-footer">
                            {/* {free === "N" && paystatus !== "paid" && ( */}
                            {localStorage.getItem("Role") !== "1" &&
                              tfree === "N" &&
                              tfree !== "" && (
                                <a
                                  onClick={paysubmit}
                                  className="btn btn-success btn-block"
                                >
                                  Submit &amp; Pay
                                </a>
                              )}
                            {localStorage.getItem("Role") !== "1" &&
                              tfree !== "N" &&
                              tfree !== "" && (
                                <a
                                  onClick={paysubmit}
                                  className="btn btn-success btn-block"
                                >
                                  Submit
                                </a>
                              )}

                            {localStorage.getItem("Role") === "1" &&
                              adminbutton === "Paid" && (
                                <a
                                  onClick={entrysubmit}
                                  className="btn btn-success btn-block"
                                >
                                  Update Entries
                                </a>
                              )}
                            {localStorage.getItem("Role") === "1" &&
                              adminbutton !== "Paid" && (
                                <a
                                  onClick={entrysubmit}
                                  className="btn btn-success btn-block"
                                >
                                  Submit Entries
                                </a>
                              )}
                            {/* )} */}

                            <div className="text-center">
                              <span>
                                * Once you submit and paid the amount for the
                                entries, entries cannot be added/edited
                              </span>
                            </div>
                          </div>
                        </Card.Body>
                      </div>
                    )}
                  </Card>
                </div>
                <Modal show={oshow} size="md">
                  <Modal.Header>QR</Modal.Header>
                  <Modal.Body>
                    <img src={oimage} />
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="text-right">
                      <a className="btn btn-gray" onClick={closeimage}>
                        {" "}
                        Close
                      </a>
                    </div>
                  </Modal.Footer>
                </Modal>

                <Modal show={show} size="md">
                  <Modal.Header>Upload Receipt</Modal.Header>
                  <Modal.Body>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">
                            Receipt{" "}
                            <span className="errortext">
                              {" "}
                              * (Accepted Files are jpg, jpeg, png and pdf only
                              )
                            </span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            accept=".jpg, .jpeg, .png, .pdf"
                            onChange={resfile}
                          />
                          {reserr !== "" && (
                            <span className="errortext"> {reserr}</span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">
                            Notes <span className="errortext"> *</span>
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            placeholder="Enter Notes"
                            rows="3"
                            onChange={(e) => setRDesc(e.target.value)}
                            value={rdesc}
                          />
                        </div>
                      </div>
                      {errmsg !== "" && (
                        <span className="errortext"> {errmsg}</span>
                      )}
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="text-right">
                      <a className="btn btn-success me-2" onClick={submitrec}>
                        {" "}
                        Upload
                      </a>
                      <a className="btn btn-gray" onClick={handleclose}>
                        {" "}
                        Close
                      </a>
                    </div>
                  </Modal.Footer>
                </Modal>
                <div className="col-lg-8 col-xxl-8 selectedathletes">
                  {gateway == 2 && (
                    <>
                      {rejrea !== "" && (
                        <>
                          <h4>Receipt Status</h4>
                          <hr className="my-1" />
                          {paytype == 1 && (
                            <h4 className="text-success">
                              Your receipt has been approved. Reason: {rejrea}
                            </h4>
                          )}
                          {paytype == 2 && (
                            <h4 className="text-danger">
                              Your receipt has been rejected. Reason: {rejrea}
                            </h4>
                          )}
                          <hr />
                        </>
                      )}

                      <h4>Account Details</h4>
                      <hr className="my-1" />
                      <Row>
                        {accdet !== "" && (
                          <Col xxl={12} lg={12} md={12}>
                            <Card className="custom-card">
                              <Card.Body className="athsummbox p-2">
                                <div className="d-flex">
                                  <div className="media align-items-center pos-relative w-100">
                                    <div className="media-body ms-3">
                                      <h4 className="abname">
                                        {accdet.account_name}
                                      </h4>
                                      <h4 className="abuid">
                                        <span>Bank Name - </span>{" "}
                                        {accdet.bank_name}
                                      </h4>
                                      <h4 className="abuid">
                                        <span>Account Number - </span>{" "}
                                        {accdet.account_number}
                                      </h4>

                                      <h4 className="abuid">
                                        <span>Branch -</span>{" "}
                                        {accdet.branch_name}
                                      </h4>
                                      <h4 className="abuid">
                                        <span>IFSC -</span> {accdet.ifsc_code}
                                      </h4>
                                    </div>

                                    <span className="tx-16 my-auto">
                                      {accdet.payment_qr_path !== "" && (
                                        <img
                                          alt="photograph"
                                          src={accpath + accdet.payment_qr_path}
                                          className="athsummbox-img"
                                          onError={(e) => errorhandle(e)}
                                          onClick={() =>
                                            openimage(
                                              accpath + accdet.payment_qr_path
                                            )
                                          }
                                        />
                                      )}
                                      {accdet.payment_qr_path === "" && (
                                        <img
                                          alt="photograph"
                                          src={require("../../../../../assets/images/users.png")}
                                          className="athsummbox-img"
                                          onError={(e) => errorhandle(e)}
                                        />
                                      )}

                                    </span>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        )}
                      </Row>
                      <hr />
                    </>
                  )}
                  <h4>All Selected Players</h4>
                  <hr className="my-1" />

                  <Row>
                    {athlete.map((data, i) => {
                      return (
                        <Col xxl={6} lg={6} md={6} key={i}>
                          <Card className="custom-card">
                            <Card.Body className="athsummbox p-2">
                              <div className="d-flex">
                                <div className="media align-items-center pos-relative w-100">
                                  <span className="tx-16 my-auto">
                                    {data.photograph !== "" && (
                                      <img
                                        alt="photograph"
                                        src={s3path + data.photograph}
                                        className="athsummbox-img"
                                        onError={(e) => errorhandle(e)}
                                      />
                                    )}
                                    {data.photograph === "" && (
                                      <img
                                        alt="photograph"
                                        src={require("../../../../../assets/images/users.png")}
                                        className="athsummbox-img"
                                        onError={(e) => errorhandle(e)}
                                      />
                                    )}
                                    <div className="mt-2">
                                      <Button
                                        variant="secondary"
                                        size="sm"
                                        onClick={() => handlepshow(data.user_id)}
                                      >
                                        <i className="fe fe-edit"></i> Edit Photo
                                      </Button>
                                    </div>
                                  </span>
                                  <div className="media-body ms-3">
                                    <h4 className="abname">
                                      {data.first_name}
                                    </h4>
                                    {grpst == "Yes" ? (
                                      <h4 className="abuid">
                                        <span>Aadhar - </span>
                                        {data.aadhaar_no}
                                      </h4>
                                    ) : (
                                      <h4 className="abuid">
                                        <span>UID - </span>
                                        {data.username}
                                      </h4>
                                    )

                                    }

                                    <h4 className="abdob">
                                      <span>DOB - </span>
                                      {moment(data.date_of_birth).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </h4>
                                    <h4 className="abdob">
                                      <span>BIB - {data.bib_no}</span>
                                    </h4>
                                    <h4 className="abdob">
                                      <span>
                                        Relay BIB - {data.relay_bib_no}
                                      </span>
                                    </h4>
                                    <h4 className="abdob">
                                      <span>{data.age_category}</span>
                                    </h4>
                                    <h4 className="abdob">
                                      <span>{data.events}</span>
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>

                  <Modal show={pshow} size="lg">
                    <Modal.Header>Upload Photograph</Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="form-label">
                              Photograph{" "}
                              <span className="errortext">
                                {" "}
                                * (Accepted Files are jpg, jpeg, png only
                                )
                              </span>
                            </label>
                            <input
                              type="file"
                              className="form-control"
                              accept=".jpg, .jpeg, .png, .pdf"
                              onChange={photofile}
                            />
                            {photoerr !== "" && (
                              <span className="errortext"> {photoerr}</span>
                            )}
                          </div>
                          {previewSrc && (
                            <div className="text-center mt-3">
                              <p className="mb-2">Preview:</p>
                              <img
                                src={previewSrc}
                                alt="Cropped Preview"
                                className="rounded border"
                                style={{
                                  width: "150px",
                                  height: "150px",
                                  objectFit: "cover",
                                  boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      {showCropper && (
                        <div style={{ height: "350px", overflow: "hidden" }}>
                          <ImageCropperModal
                            imageSrc={imageSrc}
                            onCancel={() => setShowCropper(false)}
                            onCropComplete={handleCropComplete}

                          />
                        </div>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <div className="text-right">
                        <a className="btn btn-success me-2" onClick={submitphoto}>
                          {" "}
                          Upload
                        </a>
                        <a className="btn btn-gray" onClick={handlepclose}>
                          {" "}
                          Close
                        </a>
                      </div>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};
